export const CONTACT_SUPPORT_SHORTCUT_ID = "contact_support";
